import moment from 'moment';
import { registerLocale } from 'react-datepicker';

import DefaultLocale from "date-fns/locale/en-GB/index";

import { momentLocaleLanguageMap } from '../constants/momentLocale';

export const changeDateLocale = (language) => {
  const localeLangCode = momentLocaleLanguageMap[language] || language || 'en-GB';

  // Try to load the specific locale with dynamic import
  import(/* @vite-ignore */ `date-fns/locale/${localeLangCode}/index.js`)
    .then((localeModule) => {
      const locale = localeModule.default || localeModule;
      moment.locale(localeLangCode);
      registerLocale(moment.locale(), locale);
    })
    .catch(() => {
      // Fallback to default locale if specific locale not found
      moment.locale('en-GB');
      registerLocale(moment.locale(), DefaultLocale);
    });
};
